import { BASE_URL } from "@/common/api/axios";
import { QuotesType } from "@/common/types";
import { Button, message } from "antd";

interface QuoteModalButtonsProps {
  currentStep: number;
  nextStep: () => void;
  prevStep: () => void;
  isResults: boolean;
  submitData: () => void;
  productType?: QuotesType;
}
export default function QuoteModalButtons({
  currentStep,
  nextStep,
  prevStep,
  submitData,
  productType,
}: QuoteModalButtonsProps) {
  const downloadTemplate = async () => {
    try {
      if (!productType) return;
      const res = await fetch(
        `${BASE_URL}/req/quotes/download/template?type=${productType}`,
        {
          method: "GET",
          credentials: "include",
        }
      );
      if (!res.ok) {
        throw new Error("Failed to download template");
      }
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${productType}-template.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      message.error("Failed to download the template.");
    }
  };
  return (
    <div className="flex justify-between items-center mt-4">
      {currentStep > 0 && (
        <Button
          onClick={() => prevStep()}
          className="h-10 font-inter text-base font-semibold"
        >
          Back
        </Button>
      )}
      {currentStep === 0 && (
        <Button
          type="primary"
          className="h-10 font-inter font-semibold text-base"
          onClick={() => nextStep()}
        >
          Next
        </Button>
      )}
      {currentStep === 1 && (
        <Button
          onClick={downloadTemplate}
          type="primary"
          className="h-10 font-inter text-base font-semibold"
        >
          Download template
        </Button>
      )}
      {currentStep === 1 && (
        <Button
          onClick={() => submitData()}
          type="primary"
          className="h-10 font-inter text-base font-semibold"
        >
          View results
        </Button>
      )}
    </div>
  );
}
